module.exports = __webpack_public_path__ + "static/media/my_assets_investing.cf304489.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/my_assets_investing.png
// module id = 667
// module chunks = 0 1